import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptRaffles} from "./raffles.adapter";
import type {Raffle, RafflesApiResponse} from "./raffles.types";

export interface GetRafflesParams {
  page?: number;
  pageSize?: number;
}

export const getRafflesService = async ({page = 1, pageSize = 20}: GetRafflesParams = {}): Promise<Raffle[]> => {
  const response = await httpRequest<RafflesApiResponse>({
    method: "GET",
    url: "/raffles",
    baseUrl: config.apiRootUrl,
    query: {page, pageSize},
  });
  return adaptRaffles(response);
};
